import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import branch from 'client/core/branch';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';
import ApartmentLocatorActions from 'client/actions/ApartmentLocator';
import AgentActions from 'client/actions/Agent';
import {
  placeholderProfilePicture,
  APT_LEADERBOARD_CUT_OFF_DATE,
} from 'common/apartmentLocatorHelpers';
import {
  USER_ROLE_APARTMENT_LOCATOR,
} from 'common/userRoles';

import SrCardContainer from 'client/components/SrCardContainer';
import SrAgentLeaderboardBarChart from 'client/components/SrAgentLeaderboardBarChart';
import SrLink from 'client/components/SrLink/SrLink';
import SrMonthlyFlicker from 'client/components/SrMonthlyFlicker';

@withRouter
@branch({
  locatorLeaderboard: ['apartmentLocator', 'leaderboard'],
  agentLeaderboard: ['agent', 'leaderboard'],
})
class SrAgentLeaderboardCard extends Component {

  static propTypes = {
    locatorLeaderboard: PropTypes.array,
    agentLeaderboard: PropTypes.array,
    userRole: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor() {
    super();

    this.state = {
      startDate: momentWithAustinTimezone().startOf('month'),
      endDate: momentWithAustinTimezone().endOf('month'),
    };
  }

  _onCardClicked = (event) => {
    const { history, userRole } = this.props;
    event.preventDefault();

    const leaderboardLink = userRole === USER_ROLE_APARTMENT_LOCATOR
      ? '/agent/locator-leaderboard'
      : '/agent/tour-guide-leaderboard';

    history.push(leaderboardLink);
  };

  _onMonthUpdated = (startDate, endDate) => {
    const { dispatch, userRole } = this.props;
    this.setState({
      startDate: momentWithAustinTimezone(startDate),
      endDate: momentWithAustinTimezone(endDate),
    });
    if (userRole === USER_ROLE_APARTMENT_LOCATOR) {
      dispatch(ApartmentLocatorActions.getLeaderboard, { startDate, endDate });
    }
    else {
      dispatch(AgentActions.getLeaderboard, { startDate, endDate });
    }
  }

  componentDidMount() {
    const { dispatch, userRole } = this.props;
    const { startDate, endDate } = this.state;
    if (userRole === USER_ROLE_APARTMENT_LOCATOR) {
      dispatch(ApartmentLocatorActions.getLeaderboard, { startDate, endDate });
    }
    else {
      dispatch(AgentActions.getLeaderboard, { startDate, endDate });
    }
  }

  render() {
    const {
      locatorLeaderboard,
      agentLeaderboard,
      userRole,
    } = this.props;

    const leaderboardLink = userRole === USER_ROLE_APARTMENT_LOCATOR
      ? '/agent/locator-leaderboard'
      : '/agent/tour-guide-leaderboard';

    const leaderboard = userRole === USER_ROLE_APARTMENT_LOCATOR
      ? locatorLeaderboard
      : agentLeaderboard;

    const roleIdentifier = userRole === USER_ROLE_APARTMENT_LOCATOR
      ? 'locator'
      : 'agent';

    if (!leaderboard || leaderboard.length < 3) {
      return null;
    }

    return (
      <SrCardContainer>
        <div className='SrAgentLeaderboardCard'>
          <SrMonthlyFlicker
            title='leaderboard'
            type='small'
            canSwitchMonths={false}
            onMonthUpdated={(startDate, endDate) => this._onMonthUpdated(startDate, endDate)}
            limitDate={APT_LEADERBOARD_CUT_OFF_DATE}
          />
          <div onClick={this._onCardClicked}>
            <SrAgentLeaderboardBarChart
              firstPlaceProfilePictureUrl={
                leaderboard[0][roleIdentifier].profilePicture
                  || placeholderProfilePicture
              }
              secondPlaceProfilePictureUrl={
                leaderboard[1][roleIdentifier].profilePicture
                  || placeholderProfilePicture
              }
              thirdPlaceProfilePictureUrl={
                leaderboard[2][roleIdentifier].profilePicture
                  || placeholderProfilePicture
              }
            />
            <div className='actionLinkWrapper'>
              <SrLink to={leaderboardLink}>
                <span className='link'>View Leaderboard</span>
              </SrLink>
            </div>
          </div>
        </div>
      </SrCardContainer>
    );
  }
}

SrAgentLeaderboardCard.displayName = 'SrAgentLeaderboardCard';

export default SrAgentLeaderboardCard;
